export default '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\
  <path d="M1.3 14.355L9.97 5.684L18.641 14.355" stroke="var(--color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\
</svg>'
